import { render, staticRenderFns } from "./KeywordIterator.vue?vue&type=template&id=403b4f48&scoped=true"
import script from "./KeywordIterator.vue?vue&type=script&lang=js"
export * from "./KeywordIterator.vue?vue&type=script&lang=js"
import style0 from "./KeywordIterator.vue?vue&type=style&index=0&id=403b4f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403b4f48",
  null
  
)

export default component.exports